import { Component, OnInit } from '@angular/core';
import { ConfirmationLoginDialog } from '../../components/confirmation-dialog/confirmation-login-dialog.component';
import { LoginService } from '../../services/login/login.service';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { AppService } from '../../services/app.service';
import { VotacionService } from '../../services/votacion/votacion.service';


import { BroadcastService, MsalService } from '@azure/msal-angular';
import { Logger, CryptoUtils } from 'msal';

import { MatDialog } from '@angular/material/dialog';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';

@Component({ 
selector: 'app-login', 
templateUrl: '../../pages/login/login.component.html', 
styleUrls: ['../../pages/login/login.component.css'] })

export class LoginComponent implements OnInit 
{ 
    mensajeBoton:string = "Ingreso Afiliado";
    rol:string = "afiliado";
    jubilado:boolean = false;
    muestraMenu: boolean = true;
    randomString: string;
    isIframe = false;
    loggedIn = false;
    periodoVotaciones:boolean = false;
    fechaInicioVotacion : any;
    fechaFinVotacion: any;

    constructor( private loginService: LoginService, public router: Router, private appService: AppService,
                 private broadcastService: BroadcastService, private authService: MsalService, 
                 private dialog: MatDialog, private votacionService:VotacionService) { }
 
    ngOnInit(): void 
    {
        let vm = this
        this.isIframe = window !== window.parent && !window.opener;

        this.checkAccount();

        this.broadcastService.subscribe('msal:loginSuccess', () => { this.checkAccount(); });

        this.authService.handleRedirectCallback((authError, response) => 
        {
            if (authError) 
            {
                console.error('Redirect Error: ', authError.errorMessage);
                return;
            }

            console.log('Redirect Success: ', response.accessToken);
        });

        this.authService.setLogger(new Logger((logLevel, message, piiEnabled) => {
            //console.log('MSAL Logging: ', message);
        }, {
            correlationId: CryptoUtils.createNewGuid(),
            piiLoggingEnabled: false
        }));
    }

    checkAccount() { this.loggedIn = !!this.authService.getAccount(); }
    
    login() 
    {
        const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;
    
        if (isIE) { this.authService.loginRedirect(); } 
        
        else 
        {
            let vm = this    
            if (this.periodoVotaciones) {
                this.votacionService.obtieneProductosPorId(12).then
                (
                    productos => productos[0].parametros.map(parametro => {
                        
                        if (parametro.descripcion == 'FECHA_INICIO_VOTACION') {
                            vm.fechaInicioVotacion =' parametro.valor'                  
                        }
                        if (parametro.descripcion == 'FECHA_FIN_VOTACION') {
                            vm.fechaFinVotacion = parametro.valor
                        }                    
                    })
                )
                .catch(error => console.log(error))
            }

            if(this.rol=='ejecutivo'){
                localStorage.setItem("jubilado", "false");
                this.loginEjecutivo();
            }else if(this.rol=='jubilado'){
                localStorage.setItem("jubilado", "true");
                this.claveUnicaJubilado()
            }else{
                localStorage.setItem("jubilado", "false");
                this.loginfuncionario();
            }
         
        }
    }
  
    claveUnicaJubilado() {
        this.randomString = this.generateRandomString(300); 
        let vm = this
        document.location.href = `${environment.urlClaveUnica}` + "openid/authorize/" +
            "?client_id=" + `${environment.clienteId}` +
            "&response_type=code" +
            "&scope=openid run name" +
            "&redirect_uri=" + `${environment.claveRedirectUri}` +
            "&state=" + this.randomString;        
    }
    generateRandomString(length: number): string {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        const charactersLength = characters.length;
     
        for (let i = 0; i < length; i++) {
           const randomIndex = Math.floor(Math.random() * charactersLength);
           result += characters.charAt(randomIndex);
        }
        return result;
    }

    loginfuncionario()
    {
        var vm = this;
        this.authService.loginPopup().then
            (
                response => {
                    localStorage.setItem("jwt", response.idToken.rawIdToken);
                    console.log(response.idToken.rawIdToken);
                    localStorage.setItem("nombreUsuario", response.account.name);
                    localStorage.setItem("username", response.account.userName);

                    localStorage.removeItem("rol");

                    vm.loginService.buscaRoles(response.account.userName).then
                        (
                            (response: any) => {
                                localStorage.setItem("idUsuario", response.id)
                                localStorage.setItem("rutUsuario", response.rut)
                                localStorage.setItem("dvUsuario", response.dv)

                                response.rol.forEach(rol => {
                                    if (vm.rol == "afiliado" && rol.descripcion.includes("AFILIADO")) {
                                        localStorage.setItem("rol", rol.descripcion);
                                    }
                                    else if (vm.rol == "ejecutivo" && !rol.descripcion.includes("AFILIADO")) {
                                        localStorage.setItem("rol", rol.descripcion);
                                    }
                                });

                                if (!localStorage.getItem("rol")) { localStorage.setItem("rol", "ROLE_ANONYMUS"); }

                                console.log(localStorage.getItem("rol"));

                                this.appService.setUserLoggedIn(localStorage.getItem("rol"));
                                if (!this.periodoVotaciones) {
                                    vm.router.navigate(['index']);
                                } else {
                                    this.logicaVotaciones(response.id);                                    
                                }

                            }
                        )
                        .catch(error => {
                            console.log('error', error);
                            if (error.status == 500) {

                                const dialogRef = this.dialog.open(ConfirmationLoginDialog, {

                                    data: { message: 'Usted no se encuentra afiliado al Servicio Bienestar. ¿Desea afiliarse?', buttonText: { ok: 'Si', cancel: 'No' } }

                                })
                                dialogRef.afterClosed().subscribe((confirmed: boolean) => {

                                    if (confirmed) { this.router.navigate(['/solicitud-afiliacion']) }

                                })
                            } else if (error.status == 0) {
                                vm.openAlertDialog('Ha ocurrido un problema al comunicarse con los servicios.', 'btn-dark');
                            } else {
                                vm.openAlertDialog('Ha ocurrido un problema al comunicarse con el servicio que entrega los roles.', 'btn-dark');
                            }
                        });
                }
            )
            .catch(error => { console.log('ERROR ', error) });

    }

    loginEjecutivo()
    {
        var vm = this;
        this.authService.loginPopup().then
        (
            response => 
            {
                localStorage.setItem("jwt", response.idToken.rawIdToken);
                console.log(response.idToken.rawIdToken); 
                localStorage.setItem("nombreUsuario", response.account.name);
                localStorage.setItem("username", response.account.userName);
                
                localStorage.removeItem("rol");

                vm.loginService.buscaRolesEjecutivo(response.account.userName).then
                (
                    (response: any) =>
                    {
                        localStorage.setItem("idUsuario", response.id)
                        localStorage.setItem("rutUsuario", response.rut)
                        localStorage.setItem("dvUsuario", response.dv)
                        
                        response.rol.forEach(rol => 
                        {                                
                            if(vm.rol == "afiliado" && rol.descripcion.includes("AFILIADO") )
                            {
                                localStorage.setItem("rol", rol.descripcion);        
                            } 
                            else if(vm.rol == "ejecutivo" &&  !rol.descripcion.includes("AFILIADO") )
                            {
                                localStorage.setItem("rol", rol.descripcion);    
                            }                             
                        });        
                        
                        if(!localStorage.getItem("rol")) { 
                            vm.openAlertDialog('El ejecutivo no tiene roles asignados.', 'btn-dark'); 
                            vm.router.navigate(['index']); 
                            localStorage.setItem("rol", "ROLE_ANONYMUS"); 
                        }

                        console.log(localStorage.getItem("rol"));

                        this.appService.setUserLoggedIn(localStorage.getItem("rol"));

                        vm.router.navigate(['index']); 
                    }
                )
                .catch ( error =>
                { 
                    console.log(error); 

                    if(error.status == 404 || error.status == 500)
                    {
                  
                        const dialogRef = this.dialog.open(ConfirmationLoginDialog, {
                
                            data: { message: 'Usted no se encuentra afiliado al Servicio Bienestar. ¿Desea afiliarse?', buttonText: { ok: 'Si', cancel: 'No' } }
                
                        })

                
                        dialogRef.afterClosed().subscribe((confirmed: boolean) => {
                
                            if (confirmed) { this.router.navigate(['/solicitud-afiliacion']) }
                
                        })

                    
                    }                
                    else {
                         vm.openAlertDialog('Ha ocurrido un problema al comunicarse con el servicio que entrega los roles.', 'btn-dark'); }
                } );
            }
        )
        .catch ( error => { console.log('ERROR ', error) } );
      
    }



    cambiaMensaje(rol: string)
    {
        this.rol = rol;

        if(rol == 'ejecutivo')
        {
            this.mensajeBoton = "Ingreso Ejecutivo";
            this.jubilado = false;
        }
        else if(rol == 'afiliado')
        {
            this.mensajeBoton = "Ingreso Afiliado";
            this.jubilado = false;
        }
        else
        {
            this.mensajeBoton = "Ingreso Jubilado (Clave Única)";
            this.jubilado = true;
        }
    }

    openAlertDialog(mensaje: string, clase: string)  
    {
        const dialogRef = this.dialog.open(AlertDialogComponent, 
        {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        });

        dialogRef.afterClosed().subscribe( response => {
            this.authService.logout();
        });
    }

    // Convertir las fechas a objetos Date
    private convertirFecha(fechaStr: string): Date {
        const [dia, mes, anio] = fechaStr.split("-").map(Number);
        return new Date(anio, mes - 1, dia); // Restamos 1 al mes porque los meses en JS van de 0-11
    }


    logicaVotaciones(usuarioId: any)
    {
        var vm = this;
        const fechaInicio = this.convertirFecha(this.fechaInicioVotacion);
        const fechaFin = this.convertirFecha(this.fechaFinVotacion);
        // Obtener la fecha actual sin horas/minutos/segundos
        const fechaActual = new Date();
        fechaActual.setHours(0, 0, 0, 0);
        if (fechaActual >= fechaInicio && fechaActual <= fechaFin) {
            console.log("La fecha actual está dentro del período de votación.");

            this.votacionService.existeVotacionUsuario(usuarioId)
                .then((response) => {
                    console.log("existeVotoPrevio:", response)
                    if (response == true) {
                        vm.router.navigate(['index']);
                    } else {
                        this.muestraMenu=false
                        vm.router.navigate(['votacion']);
                    }
                })
                .catch((error) => {
                    console.error(error);
                    vm.router.navigate(['index']);
                });

        } else {
            console.log("Fuera del período de votación.");
            vm.router.navigate(['index']);
        }     
    }

}